export const blogs:any = {
    count:0
}